import { exists } from "../../../_helper/util.helper";
import { PropertyModel } from "../../property/property.model";

export class StatusChangeConfigModel {

  //do not require user to select status for Draft -> New
  public automaticActivate: boolean = true;

  //preview from status change
  public showPreviewButton: boolean = true;

  //price warning
  public showPriceWarning: boolean = true;

  //map location warning
  public alwaysShowMapWarning: boolean = true;
  public showMapWarning: boolean = true;

  //price change % alert from previous price
  public showPriceAlert: boolean = true;
  public priceAlertPercent: number = 15;

  constructor(model?: Partial<StatusChangeConfigModel>) {
    if (exists(model?.automaticActivate)) this.automaticActivate = model.automaticActivate;
    if (exists(model?.showPreviewButton)) this.showPreviewButton = model.showPreviewButton;
    if (exists(model?.alwaysShowMapWarning)) this.alwaysShowMapWarning = model.alwaysShowMapWarning;
    if (exists(model?.showMapWarning)) this.showMapWarning = model.showMapWarning;
    if (exists(model?.showPriceAlert)) this.showPriceAlert = model.showPriceAlert;
    if (exists(model?.priceAlertPercent)) this.priceAlertPercent = model.priceAlertPercent;
  }

  public activateAutomatically(listing: PropertyModel): boolean {
    return this.automaticActivate && listing.MlsStatus === 'Draft';
  }

  public showWarnings(listing: PropertyModel): boolean {
    return this.showMap(listing) || this.showPrice();
  }

  public showPrice(): boolean {
    return this.showPriceWarning;
  }

  public showMap(listing: PropertyModel): boolean {
    return this.alwaysShowMapWarning ||
          this.showMapWarning && (!listing.Latitude || !listing.Longitude);
  }
}
